import { useState } from "react";

function HostedVerticalMedia({ instagramUrl, mediaUrl, posterUrl, title, compact = false }) {
  const [hasError, setHasError] = useState(false);
  const showVideo = Boolean(mediaUrl) && !hasError;

  return (
    <div className="hostedMediaCard">
      <div className={`hostedMediaCard__viewport${compact ? " hostedMediaCard__viewport--compact" : ""}`}>
        {showVideo ? (
          <video
            className="hostedMediaCard__video"
            controls
            playsInline
            muted
            preload="metadata"
            poster={posterUrl || undefined}
            onError={() => setHasError(true)}
          >
            <source src={mediaUrl} />
            Your browser does not support embedded video.
          </video>
        ) : (
          <div className="hostedMediaCard__placeholder" aria-label={`${title} placeholder`}>
            <span>Add hosted vertical video</span>
          </div>
        )}
      </div>

      {instagramUrl ? (
        <a
          className="button button--secondary hostedMediaCard__link"
          href={instagramUrl}
          target="_blank"
          rel="noreferrer"
        >
          View on Instagram
        </a>
      ) : null}
    </div>
  );
}

export default HostedVerticalMedia;
